import React from "react";
import Btn from "../../Components/Btn/Btn";
import useSignUp from "./Hooks/useSignUp";
import { useLocation } from "react-router";
import Spinner from "react-bootstrap/Spinner";
const SignUp = () => {
  const { submit, setForm, form, loading } = useSignUp();
  const { state } = useLocation();
  const { mobile } = state;
  console.log("f", form);

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <div className="sign-up">
            <div className="sign-box">
              <div className="sign-img">
                <img
                  src={require("../../assets/images/logo.png")}
                  style={{ width: "120px", objectFit: "contain" }}
                />
              </div>
              <div className="sign-title">
                <p className="title">ثبت نام</p>
                <p className="content">
                  لطفا نام و نام خانوادگی خود را وارد نمایید
                </p>
              </div>
              <div className="sign-input">
                <input
                  className="content"
                  onChange={({ target: { value } }) => {
                    setForm({ fullname: value });
                  }}
                />
                <input className="conTent" value={mobile} disabled={true} />
              </div>
              <div className="sign-button">
                <div
                  className="content"
                  onClick={() => {
                    submit(mobile);
                  }}
                >
                  {loading ? (
                    <Spinner
                      animation="border"
                      role="status"
                      size="sm"
                      style={{ color: "white" }}
                    >
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    <span className="textBtn">ثبت نام</span>
                  )}
                </div>
              </div>
              <div className="sign-warning">
                <p className="text">
                  ورود شما به معنای قبول شرایط صنعتبان و قوانین حریم خصوصی می
                  باشد.
                </p>
              </div>
              <div className="sign-footnote">
                <p className="title">نیازمندی های رایگان صنعت</p>
                <p className="text">تلفن پشتیبانی: 02191027127</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SignUp;
